import { gql, useQuery } from '@apollo/client';
import { backendNameToLabel } from '../../../utils/formatting';

export const PENDING_ELECTION_SEARCH_BY_OPTIONS = gql`
  query PendingElectionSearchByOptions {
    pendingElectionSearchByFields
  }
`;

export default function usePendingElectionSearchByOptions() {
  const { loading, error, data } = useQuery(PENDING_ELECTION_SEARCH_BY_OPTIONS, {
    onCompleted: () => {},
    onError: () => {}
  });

  return {
    pendingElectionSearchByOptions:
      data?.pendingElectionSearchByFields?.map(field => ({
        label: backendNameToLabel(field),
        value: field
      })) || [],
    loading,
    error
  };
}
